import React, { useEffect, useState } from 'react'
import { useForm, Controller } from 'react-hook-form';
import { DatePicker } from "rsuite";
import { apiUrl } from '../../../ApiHelper/ApiUrl';
import { callApi } from '../../../ApiHelper/ApiHelper';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Modal, Spinner } from 'reactstrap';
import { getCurrentLocation } from '../../../utility/CommonFunctions';
import { useLocation, useNavigate } from 'react-router-dom';
import { RoutesLink } from '../../../ApiHelper/RoutesLink';
import BackArrowIcon from '../../../components/Icons/BackArrowIcon';
import MapComponent from '../../../components/comman/MapComponent';
import ErrorMessage from '../../../components/comman/ErrorMessage';

export default function AddOdRequest() {
    const { register, handleSubmit, formState: { errors }, clearErrors, watch, reset, setValue, setError, control, trigger } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [loadingLocation, setLoadingLocation] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const EditOdData = location?.state?.EditOdData || null
    const [stateOd, setStateOd] = useState({
        lat: null,
        lng: null,
        address: null,
    });
    const [markers, setMarkers] = useState([{ lat: 28.0229, lng: 73.3119 }]);
    const apiKey = import.meta.env.VITE_APP_API_KEY;
    const [file, setFile] = useState({
        file: null,
        imageUrl: null,
        deleteUrl: null,
        isDelete: false
    });

    const onSubmit = (data) => {
        if (!stateOd?.lat && !stateOd?.lng) {
            return;
        }
        const postData = {
            ...(EditOdData !== null && { odRequestId: EditOdData?.id }),
            communicationMode: data?.modeOfCommunication,
            clientName: data?.cilentName,
            contactPersonName: data?.contactPerson,
            phoneNumber: data?.contactNumber,
            visit: data?.placeToVisit,
            reason: data?.reason,
            discussion: data?.discussionSummary,
            remark: data?.remark,
            locationName: data?.address,
            location: {
                lat: stateOd?.lat,
                lng: stateOd?.lng
            },
            startDate: data?.checkindate,
            endDate: data?.checkoutdate,
        };

        // const formData = new FormData();
        // Object.keys(postData).forEach((key) => {
        //     const value = postData[key];
        //     if (value) { // Check if the value exists before appending
        //         formData.append(key, value);
        //     }
        // });

        const option = {
            method: 'POST',
            data: postData,
        };

        // console.log(postData);

        setIsLoading(true);

        const endPoint = EditOdData !== null ? apiUrl.edit_od : apiUrl.create_od;
        // Call the API
        callApi(endPoint, option)
            .then((res) => {
                if (res?.status === true) {
                    toast.success(res?.message);
                    navigate(RoutesLink.my_od);
                    reset();
                } else {
                    toast.error(res?.message);
                }
            })
            .catch(() => {
                toast.error('An error occurred');
            })
            .finally(() => setIsLoading(false));

    }

    const handleGetAddress = async (lat, lng) => {
        const geocoder = new window.google.maps.Geocoder();
        const latLng = { lat: parseFloat(lat), lng: parseFloat(lng) };
        setLoadingLocation(true);
        geocoder.geocode({ location: latLng }, (results, status) => {
            setLoadingLocation(false);
            if (status === "OK") {
                if (results[0]) {
                    setStateOd((pre) => ({
                        ...pre,
                        address: results[0].formatted_address
                    }));
                    setValue('address', results[0].formatted_address);
                    setError('address', '');
                } else {
                    console.error("No results found");
                }
            } else {
                console.error("Geocoder failed due to: " + status);
            }
        });
    };

    useEffect(() => {
        // console.log(EditOdData);
        if (EditOdData !== null) {
            const startDate = moment(EditOdData?.startDate).format("YYYY-MM-DD");
            const checkInTime = moment(EditOdData?.endDate).format("YYYY-MM-DD")
            setValue('reason', EditOdData?.reasonOd);
            setValue('modeOfCommunication', EditOdData?.communicationMode);
            setValue('cilentName', EditOdData?.clientName)
            setValue('contactPerson', EditOdData?.contactPersonName)
            setValue('contactNumber', EditOdData?.phoneNumber)
            setValue('placeToVisit', EditOdData?.visit)
            setValue('address', EditOdData?.locationName)
            setValue('discussionSummary', EditOdData?.discussion)
            setValue('remark', EditOdData?.remark)
            setValue('checkindate', startDate);
            setValue('checkoutdate', checkInTime);
            const lat = parseFloat(EditOdData?.location?.lat);
            const lng = parseFloat(EditOdData?.location?.lng);
            setStateOd((pre) => ({
                ...pre,
                lat: isFinite(lat) ? lat : 28.0229,
                lng: isFinite(lng) ? lng : 73.3119
            }));
            setMarkers([{
                lat: isFinite(lat) ? lat : 28.0229,
                lng: isFinite(lng) ? lng : 73.3119
            }]);
        } else {
            reset();
            getCurrentLocation()
                .then((location) => {
                    if (location?.latitude && location?.longitude) {
                        setStateOd((pre) => ({
                            ...pre,
                            lat: location.latitude,
                            lng: location.longitude,
                        }));
                        setMarkers([{ lat: location.latitude, lng: location.longitude }]);
                    }
                })
                .catch((err) => {
                    // console.error("Location error:", err);
                    // Fallback to default coordinates if geolocation fails
                    setStateOd((pre) => ({
                        ...pre,
                        lat: 28.0229,
                        lng: 73.3119,
                    }));
                    setMarkers([{ lat: 28.0229, lng: 73.3119 }]);
                });
        }
    }, [EditOdData])


    return (
        <>
            <div className="content container-fluid">
                <div className="content-head mb-5 d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center justify-content-start gap-4">
                        <button className="btn back-arrow" onClick={() => navigate(-1)}>
                            <BackArrowIcon />
                        </button>
                        <h1 className="mb-0">
                            {EditOdData ? "Edit" : "Apply"} O.D. Request
                        </h1>
                    </div>
                </div>
                <form className="row" onSubmit={handleSubmit(onSubmit)} id="ArRequestForm">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="row">
                                    <div className="col-12 mb-4">
                                        <h4>Location</h4>
                                        <MapComponent
                                            apiKey={apiKey}
                                            center={stateOd}
                                            markers={markers}
                                            // circleRadius={circleRadius || 0}
                                            onMarkerDragEnd={(position) => {
                                                // Update the form values and map state with new position
                                                // console.log(position);

                                                // setValueSecond("lat", position.lat);
                                                // setValueSecond("lng", position.lng);
                                                setStateOd((pre) => ({
                                                    ...pre,
                                                    lat: position.lat,
                                                    lng: position.lng,
                                                    address: ""
                                                }));
                                                setValue('address', '');
                                                setMarkers([
                                                    { lat: position.lat, lng: position.lng },
                                                ]);
                                            }}
                                        />
                                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-3">
                                            <button type="button" className="btn btn-primary px-5" onClick={() => handleGetAddress(stateOd?.lat, stateOd?.lng)}>
                                                {loadingLocation ? <Spinner /> : "Get Location"}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-6">
                                        <div className="form-group mb-3">
                                            <label htmlFor="attsts" className="form-label">
                                                Mode of Communication <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                className="form-select"
                                                aria-label="Default select example"
                                                id="modeOfCommunication"
                                                {...register("modeOfCommunication", { required: "Mode of Communication is required" })}
                                            >
                                                <option value="">Select</option>
                                                <option value="Visit">Visit</option>
                                            </select>
                                            <ErrorMessage message={errors?.modeOfCommunication?.message} />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-6">
                                        <div className="form-group mb-3">
                                            <label htmlFor="wrktyp" className="form-label">
                                                Client Name
                                                {/* <span className="text-danger">*</span> */}
                                            </label>
                                            <input
                                                className="form-control"
                                                id="cilentName"
                                                placeholder='Cilent Name'
                                                {...register("cilentName",
                                                    // { required: "Cilent Name is required" }
                                                )}
                                            />
                                            <ErrorMessage message={errors?.cilentName?.message} />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-6">
                                        <div className="form-group mb-3">
                                            <label htmlFor="wrktyp" className="form-label">
                                                Contact Person
                                                {/* <span className="text-danger">*</span> */}
                                            </label>
                                            <input
                                                className="form-control"
                                                id="cilentName"
                                                placeholder='Contact Person'
                                                {...register("contactPerson",
                                                    // { required: "Contact Person is required" }
                                                )}
                                            />
                                            {/* <ErrorMessage message={errors?.contactPerson?.message} /> */}
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6 col-lg-6">
                                        <div className="form-group mb-3">
                                            <label htmlFor="holidayDate" className="form-label">
                                                Contact Number
                                                {/* <span className="text-danger">*</span> */}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="holidayDate"
                                                placeholder='Phone Number'
                                                {...register('contactNumber',
                                                    // { required: 'Contact number is required' }
                                                )}
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/\D/g, '');
                                                }}
                                            />
                                            {/* <ErrorMessage message={errors?.contactNumber?.message} /> */}
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-6">
                                        <div className="form-group mb-3">
                                            <label htmlFor="wrktyp" className="form-label">
                                                Place To Visit <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                className="form-control"
                                                aria-label="Default select example"
                                                id="placeToVisit"
                                                {...register("placeToVisit", { required: "Place To Visit is required" })}
                                            />
                                            <ErrorMessage message={errors?.placeToVisit?.message} />
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6 col-lg-6">
                                        <div className="form-group mb-3">
                                            <label htmlFor="chkindate" className="form-label">
                                                Check In Date <span className="text-danger">*</span>
                                            </label>
                                            <Controller
                                                name="checkindate"
                                                control={control}
                                                rules={{
                                                    required: "Check-in date is required",
                                                    validate: (value) => {
                                                        if (value && moment(value).startOf('day').isAfter(moment().startOf('day'))) {
                                                            return "Future dates are not allowed";
                                                        }
                                                        return true;
                                                    }
                                                }}
                                                defaultValue={moment().format("YYYY-MM-DD")}
                                                render={({ field }) => (
                                                    <DatePicker size="sm"
                                                        {...field}
                                                        id="chkindate"
                                                        format="dd/MM/yyyy"
                                                        oneTap
                                                        placeholder="dd/mm/yyyy"
                                                        style={{ width: "100%" }}
                                                        value={field.value ? new Date(field.value) : null}
                                                        onChange={(date) => {
                                                            field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                                                            trigger("checkoutdate");
                                                        }}
                                                        shouldDisableDate={(date) =>
                                                            moment(date).startOf('day').isAfter(moment().startOf('day'))
                                                        }
                                                        cleanable={false}
                                                    />
                                                )}
                                            />
                                            <ErrorMessage message={errors?.checkindate?.message} />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-6">
                                        <div className="form-group mb-3">
                                            <label htmlFor="checkoutdate" className="form-label">
                                                Check Out Date <span className="text-danger">*</span>
                                            </label>
                                            <Controller
                                                name="checkoutdate"
                                                control={control}
                                                rules={{
                                                    required: "Check-out date is required",
                                                    validate: (value) => {
                                                        if (value && moment(value).startOf('day').isAfter(moment().startOf('day'))) {
                                                            return "Future dates are not allowed";
                                                        }
                                                        const checkin = watch("checkindate");
                                                        if (checkin && moment(value).startOf('day').isBefore(moment(checkin).startOf('day'))) {
                                                            return "Check-out date cannot be earlier than check-in date";
                                                        }
                                                        return true;
                                                    }
                                                }}
                                                defaultValue={watch('checkindate') ? watch('checkindate') : moment().format("YYYY-MM-DD")}
                                                render={({ field }) => (
                                                    <DatePicker size="sm"
                                                        {...field}
                                                        id="checkoutdate"
                                                        format="dd/MM/yyyy"
                                                        oneTap
                                                        placeholder="dd/mm/yyyy"
                                                        style={{ width: "100%" }}
                                                        value={field.value ? new Date(field.value) : null}
                                                        onChange={(date) => {
                                                            field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                                                        }}
                                                        shouldDisableDate={(date) => {
                                                            const isFuture = moment(date).startOf('day').isAfter(moment().startOf('day'));
                                                            const isBeforeCheckIn = watch('checkindate') && moment(date).startOf('day').isBefore(moment(watch('checkindate')).startOf('day'));
                                                            return Boolean(isFuture || isBeforeCheckIn);
                                                        }}
                                                        cleanable={false}
                                                    />
                                                )}
                                            />
                                            <ErrorMessage message={errors?.checkoutdate?.message} />
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6 col-lg-6">
                                        <div className="form-group mb-3">
                                            <label htmlFor="desc" className="form-label">
                                                Address <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                className="form-control"
                                                id="address"
                                                placeholder="Address..."
                                                {...register("address", { required: "Address is required" })}
                                                disabled
                                            />
                                            <ErrorMessage message={errors?.address?.message} />
                                        </div>
                                    </div>

                                    {/* <div className="col-12 col-md-6 col-lg-6">
                                        <div className="form-group mb-3">
                                            <label htmlFor="desc" className="form-label">
                                                Discussion Of Summary <span className="text-danger">*</span>
                                            </label>
                                            <textarea
                                                className="form-control"
                                                rows={3}
                                                id="discussionSummary"
                                                placeholder=" Discussion Of Summary "
                                                {...register("discussionSummary", { required: " Discussion Of Summary is required" })}
                                            />
                                            {errors.discussionSummary && <div className="text-danger">{errors.discussionSummary.message}</div>}
                                        </div>
                                    </div> */}
                                    <div className="col-12 col-md-6 col-lg-6">
                                        <div className="form-group mb-3">
                                            <label htmlFor="desc" className="form-label">
                                                Reason To Visit <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                className="form-control"
                                                id="reason"
                                                placeholder="Reason To Visit"
                                                {...register("reason", { required: "Reason to visit is required" })}
                                            />
                                            <ErrorMessage message={errors?.reason?.message} />
                                        </div>
                                    </div>
                                    {/* <div className="col-12 col-md-6 col-lg-6">
                                        <div className="form-group mb-3">
                                            <label htmlFor="desc" className="form-label">
                                                Remark <span className="text-danger">*</span>
                                            </label>
                                            <textarea
                                                className="form-control"
                                                rows={3}
                                                id="remark"
                                                placeholder="Remark"
                                                {...register("remark", { required: "Remark is required" })}
                                            />
                                            {errors.remark && <div className="text-danger">{errors.remark.message}</div>}
                                        </div>
                                    </div> */}
                                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-3">
                                        <button className="btn btn-secondary px-5" type="button" onClick={() => navigate(-1)}>
                                            Cancel
                                        </button>
                                        <button type="submit" className="btn btn-primary px-5">
                                            {isLoading ? <Spinner /> : location?.state?.EditData ? "Edit O.D. Request" : "Apply O.D. Request"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>

    )
}


